import { smoothScroll } from '../../General/SmoothScroll';

const btn = document.querySelector('.footer__arrow');
if (btn) {
    btn.addEventListener('click', () => {
        smoothScroll(0, 600);
    });
}
